import MenuService from "@/services/MenuService";
export default {

  computed: {
    isBannerMgr: function () {
      return this.$store.getters.loggedAdmin.role == 3;
    }
  },

  methods: {
    changeStatus(entry, menuType) {
      this.$store.dispatch("setLoading", true);
      let data = JSON.parse("{}");
      data.id = entry.id;
      if (entry.status == 1) data.status = 0;
      else data.status = 1;

      var request = menuType == "sub"
        ? MenuService.changeSubStatus
        : menuType == "top"
          ? MenuService.changeTopStatus
          : MenuService.changeStatus;

      request({}, data).then(response => {
        if (response.status == 200 && response.data.success == true) {
          if (response.data.payload.toast != null)
            this.showToast(response.data.payload.toast);
          entry.status = data.status;
          this.$store.dispatch("setLoading", false);
        }
      });
    },
  }
};
